/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Missing_1Inputs */

const en_vc_status_missing_1 = /** @type {(inputs: Vc_Status_Missing_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reliable exchange of real-world .ai files`)
};

const zh_vc_status_missing_1 = /** @type {(inputs: Vc_Status_Missing_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与真实 .ai 文件的稳定互通`)
};

/**
* | output |
* | --- |
* | "Reliable exchange of real-world .ai files" |
*
* @param {Vc_Status_Missing_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_missing_1 = /** @type {((inputs?: Vc_Status_Missing_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Missing_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_missing_1(inputs)
	return zh_vc_status_missing_1(inputs)
});
export { vc_status_missing_1 as "vc.status.missing.1" }